import { useFormContext, useFormField } from '@calendly/form'
import { useEffect } from 'react'

export const useValidateOnChange = (name) => {
  const [{ value }] = useFormField(name)
  const { setFieldTouched } = useFormContext()

  useEffect(() => {
    setFieldTouched(name, true, true)
  }, [value, setFieldTouched, name])
}
